import type { DevAssistantFixture, MastraChunk } from './dev-mocks.fixtures';

const finishChunks: readonly MastraChunk[] = [
  { type: 'step-finish', payload: { stepResult: { reason: 'stop', isContinued: false } } },
  { type: 'finish', payload: { stepResult: { reason: 'stop', isContinued: false } } },
];

const askDecisionChunks = (
  question: string,
  options: Array<{ label: string; value: string }>,
  confirmLabel?: string,
): readonly MastraChunk[] => [
  { type: 'start', payload: { messageId: 'm-decision' } },
  { type: 'step-start', payload: {} },
  { type: 'text-start', payload: { id: 't1' } },
  { type: 'text-delta', payload: { id: 't1', text: 'Happy to help — one thing first.' } },
  { type: 'text-end', payload: { id: 't1' } },
  {
    type: 'data-ask-decision',
    payload: {
      decisionId: 'dec-1',
      question,
      options,
      ...(confirmLabel ? { confirm_label: confirmLabel } : {}),
    },
  },
  ...finishChunks,
];

const answeredDecisionMessages = [
  { id: 'u1', role: 'user', content: 'Draft an outreach email to Jane' },
  {
    id: 'a1',
    role: 'assistant',
    content: {
      format: 2,
      parts: [
        { type: 'text', text: 'Happy to draft that. One question first.' },
        {
          type: 'data-ask-decision',
          data: {
            decisionId: 'dec-answered',
            question: 'Which tone should the email use?',
            options: [
              { label: 'Formal', value: 'tone-formal' },
              { label: 'Casual', value: 'tone-casual' },
              { label: 'Playful', value: 'tone-playful' },
            ],
          },
        },
      ],
      content: '',
    },
  },
  {
    id: 'u2',
    role: 'user',
    content: {
      format: 2,
      parts: [{ type: 'text', text: 'tone-casual' }],
      metadata: { displayLabel: 'Casual' },
    },
  },
  { id: 'a2', role: 'assistant', content: 'Here is a casual draft you can tweak.' },
];

export const ASK_DECISION_DEV_FIXTURES: readonly DevAssistantFixture[] = [
  {
    id: 'ask-decision-radio',
    label: 'Ask decision — radio options',
    description: 'Text then a data-ask-decision chunk with 3 options (radio rows).',
    responseChunks: askDecisionChunks('Which tone should the email use?', [
      { label: 'Formal', value: 'tone-formal' },
      { label: 'Casual', value: 'tone-casual' },
      { label: 'Playful', value: 'tone-playful' },
    ]),
  },
  {
    id: 'ask-decision-dropdown',
    label: 'Ask decision — dropdown (6 options)',
    description: '6 options render as a dropdown; custom confirm label.',
    responseChunks: askDecisionChunks(
      'Which stage should I move the candidate to?',
      [
        { label: 'Sourced', value: 'stage-sourced' },
        { label: 'Applied', value: 'stage-applied' },
        { label: 'Phone screen', value: 'stage-phone-screen' },
        { label: 'Interview', value: 'stage-interview' },
        { label: 'Offer', value: 'stage-offer' },
        { label: 'Hired', value: 'stage-hired' },
      ],
      'Use this',
    ),
  },
  {
    id: 'ask-decision-answered-reload',
    label: 'Ask decision — reload (answered)',
    description: 'Seeded thread with an already-answered decision; card renders collapsed.',
    threads: [
      {
        id: 't-decision',
        title: 'Outreach email',
        updatedAt: new Date('2026-04-17T10:00:00Z'),
        pinned: false,
      },
    ],
    threadMessages: { 't-decision': answeredDecisionMessages },
  },
];
